import { AnalogIn, AnalogOut, AssignementType, DigitalIn, DigitalOut, IOType, RangedKanaal, RangedKanaalAssign } from "../props/PropTypes";
import { HwdSysteem } from "./hdw-config/HdwSysteem";

export function kanaalLabel(kanaal: number, kType: IOType): string {
  let isA = kanaal % 2 & 1;
  if (AnalogIn.equals(kType)) {
    if (kanaal == 1) {
      return "a";
    }
    if (isA) {
      return (kanaal >> 1).toString() + "a";
    } else {
      return (kanaal >> 1).toString();
    }
  } else {
    return kanaal.toString();
  }
}

export function rangedKanaalLabel(rangedKanaal: RangedKanaal): string {
  let ret = kanaalLabel(rangedKanaal.start, rangedKanaal.ioType);
  if (rangedKanaal.range > 1) {
    ret += "\u2192" + kanaalLabel(rangedKanaal.start + rangedKanaal.range - 1, rangedKanaal.ioType);
    return "Kanalen: " + ret;
  }
  return "Kanaal: " + ret;
}

export function kanaalLabelHdw(kanaal: number, ioType: IOType): string {
  let kNumber = rangedKanaalLabel({
    ioType: ioType,
    range: 1,
    start: kanaal
  }).split(": ")[1];
  if (ioType.equals(AnalogIn) && kanaal % 2 == 1) {
    return "a";
  }
  return ioType.toString() + ":" + kNumber;
}



export function getKanaalAssignement(ret: Record<string, Array<Array<RangedKanaalAssign>>>, ioType: IOType, kanaal: number) {
  let ioTypeStr = ioType.toString();
  if (ret[ioTypeStr] == undefined) {
    ret[ioTypeStr] = [];
  }
  if (ret[ioTypeStr][kanaal] == undefined) {
    ret[ioTypeStr][kanaal] = [];
  }
  return ret[ioTypeStr][kanaal];
}

export function buildKanaalMap(assignement: RangedKanaalAssign[]): Record<string, Array<Array<RangedKanaalAssign>>> {
  let ret: Record<string, Array<Array<RangedKanaalAssign>>> = {};
  for (let a of assignement) {
    for (let k = 0; k < a.rangedKnaal.range; k++) {
      if (a.rangedKnaal.start > 0) {
        let kanaal = a.rangedKnaal.start + k;
        let cell = getKanaalAssignement(ret, a.rangedKnaal.ioType, kanaal);
        cell.push(a);
      }
    }
  }

  return ret;

}
export function getAssignment(ioType: IOType, kanaal: number, map: Record<string, Array<Array<RangedKanaalAssign>>>): Array<RangedKanaalAssign> {
  let ioTypeStr = ioType.toString();
  if (map[ioTypeStr] == undefined) {
    return [];
  }
  if (map[ioTypeStr][kanaal] == undefined) {
    return [];
  }
  return map[ioTypeStr][kanaal];
}


function compactRanges(ranges: RangedKanaal[]) {
  ranges.sort((a,b) => a.start - b.start);
  let ret: RangedKanaal[] = [];
  if (ranges.length == 0) {
    return ret;
  }
  let current = ranges[0];
  for (let i = 1; i < ranges.length; i++) {
    if (ranges[i].start == current.start + current.range) {
      current.range = current.range + ranges[i].range;
    } else {
      ret.push(current);
      current = ranges[i];
    }
  }
  ret.push(current);
  return ret;
}

export function getAvailableRanges(s: HwdSysteem): Record<string, RangedKanaal[]> 
{
  let hdwIOS = s.getAllIOs();
  let diIOs = hdwIOS.filter(k => k.ioType.equals(DigitalIn));
  let doIOs = hdwIOS.filter(k => k.ioType.equals(DigitalOut));
  let aiIOs = hdwIOS.filter(k => k.ioType.equals(AnalogIn));
  let aoIOs = hdwIOS.filter(k => k.ioType.equals(AnalogOut));

  return {
    [DigitalIn.toString()]: compactRanges(diIOs),
    [DigitalOut.toString()]: compactRanges(doIOs),
    [AnalogIn.toString()]: compactRanges(aiIOs),
    [AnalogOut.toString()]: compactRanges(aoIOs)
  };

}


export function inRangePredicate(start: number, range: number, ranges: RangedKanaal[] | undefined): boolean {
  if (ranges == undefined) {
    return false;
  }
  // 0 is always available (actually the I/O set to null are bogus and they are there only for some XML/serialization reasons)
  if (start == 0) {
    return true;
  }
  for (let r of ranges) {
    if (start >= r.start && (start + range) <= r.start + r.range) {
      return true;
    }
  }
  return false;
}

export function checkAssignPredicate( a: RangedKanaalAssign, ranges: RangedKanaal[] | undefined): boolean {
  return inRangePredicate(a.rangedKnaal.start, a.rangedKnaal.range, ranges);
}

export function getNextAvailableKanaal(start:number, ranges: RangedKanaal[]) {
  for (let i = 0; i < ranges.length; i++) {
    let r = ranges[i];
    if (r.start > start) {
      return r.start;
    }
    if (r.start + r.range > start) {
      return start;
    }
  }
  return 0;
}

export function assignmentKey(assignementType: AssignementType, afdIdx: number, index: number, subIndex: number | undefined): string {
  let a = 'default';
  switch (assignementType) {
    case 'ai':
      a = 'ai';
      break;
    case 'droogwand':
    case 'koeling':
    case 'losdef':
    case 'verwarming':
      a = 'losdef';
      break;
    case 'servo':
      a = 'servo';
      break;
    case 'servoparam':
      a = 'servoparam';
      break;
    case 'bijzPrg':
      a = 'bijzprog';
      break;
    case 'uren':
      a = 'uren';
      break;
  }
  if (subIndex != undefined) {
    return `${afdIdx}_${a}_${index}_${subIndex}`;
  }
  return `${afdIdx}_${a}_${index}`;
}